import React, { useState } from 'react';
import FormInput from '../components/FormInput';
import FormTextarea from '../components/FormTextarea';
import styles from '../app.module.css'
import { validateInfoFields } from '../Utils/validationUtils.js';

const InfoSection = ({ formData, handleInputChange, handleNestedInputChange, selectedVersion }) => {
  const [tempInfo, setTempInfo] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});

  const validateFields = () => {
    const newErrors = validateInfoFields(tempInfo);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSave = () => {
    if (!validateFields()) return;

    handleInputChange('info', 'title', tempInfo.title);
    if (selectedVersion === "3.1.0") handleInputChange('info', 'summary', tempInfo.summary);
    handleInputChange('info', 'description', tempInfo.description);
    handleInputChange('info', 'version', tempInfo.version);
    handleInputChange('info', 'termsOfService', tempInfo.termsOfService);
    handleNestedInputChange('info', 'contact', 'name', tempInfo.contact.name);
    handleNestedInputChange('info', 'contact', 'url', tempInfo.contact.url);
    handleNestedInputChange('info', 'contact', 'email', tempInfo.contact.email);
    handleNestedInputChange('info', 'license', 'name', tempInfo.license.name);
    if (selectedVersion === "3.1.0") handleNestedInputChange('info', 'license', 'identifier', tempInfo.license.identifier);
    handleNestedInputChange('info', 'license', 'url', tempInfo.license.url);

    setIsEditing(false);
    setTempInfo(null);
    setErrors({});
  };

  const handleCancel = () => {
    setIsEditing(false);
    setTempInfo(null);
    setErrors({});
  };

  const handleEdit = () => {
    setTempInfo({ ...formData });
    setIsEditing(true);
  };

  return (
    <div>
      <h3 className={styles.centeredHeading}>API Info</h3>

      {formData?.title && !isEditing ? (
        <div
          className={styles.mainContainer}
        >
          <p><strong>Title:</strong> {formData.title}</p>
          {selectedVersion === "3.1.0" && <p><strong>Summary:</strong> {formData.summary || 'N/A'}</p>}
          <p><strong>Description:</strong> {formData.description || 'N/A'}</p>
          <p><strong>Version:</strong> {formData.version}</p>
          <p><strong>Terms of Service:</strong> {formData.termsOfService || 'N/A'}</p>

          <h4>Contact</h4>
          <p><strong>Name:</strong> {formData.contact.name || 'N/A'}</p>
          <p><strong>URL:</strong> {formData.contact.url || 'N/A'}</p>
          <p><strong>Email:</strong> {formData.contact.email || 'N/A'}</p>

          <h4>License</h4>
          <p><strong>Name:</strong> {formData.license.name || 'N/A'}</p>
          {selectedVersion === "3.1.0" && <p><strong>Identifier:</strong> {formData.license.identifier || 'N/A'}</p>}
          <p><strong>URL:</strong> {formData.license.url || 'N/A'}</p>

          <div className={styles.actionButtonsContainer}>
            <button
              className={styles.editButton}
              onClick={handleEdit}
            >
              Edit
            </button>
            <button
              className={styles.deleteButton}
              onClick={() => {
                handleInputChange('info', 'title', '');
                handleInputChange('info', 'description', '');
                handleInputChange('info', 'summary', '');
                handleInputChange('info', 'version', '');
                handleInputChange('info', 'termsOfService', '');
                handleNestedInputChange('info', 'contact', 'name', '');
                handleNestedInputChange('info', 'contact', 'url', '');
                handleNestedInputChange('info', 'contact', 'email', '');
                handleNestedInputChange('info', 'license', 'name', '');
                handleNestedInputChange('info', 'license', 'identifier', '');
                handleNestedInputChange('info', 'license', 'url', '');
              }}
            >
              Delete
            </button>
          </div>
        </div>
      ) : isEditing || tempInfo ? (
        <div className={styles.editMainContainer}>
          <FormInput label={<>
            Title <span className={styles.requiredField}>*</span>
          </>} value={tempInfo?.title || ''} onChange={(value) => setTempInfo({ ...tempInfo, title: value })} />
          {errors.title && <p className={styles.inlineAlerts}>{errors.title}</p>}

          {selectedVersion === "3.1.0" && (
            <FormInput label="Summary" value={tempInfo?.summary || ''} onChange={(value) => setTempInfo({ ...tempInfo, summary: value })} />
          )}

          <FormTextarea label={<>
            Description <span className={styles.requiredField}>*</span>
          </>} value={tempInfo?.description || ''} onChange={(value) => setTempInfo({ ...tempInfo, description: value })} />
          {errors.description && <p className={styles.inlineAlerts}>{errors.description}</p>}
          <FormInput label={<>
            Version <span className={styles.requiredField}>*</span>
          </>} value={tempInfo?.version || ''} onChange={(value) => setTempInfo({ ...tempInfo, version: value })} />
          {errors.version && <p className={styles.inlineAlerts}>{errors.version}</p>}

          <FormInput label="Terms of Service" value={tempInfo?.termsOfService || ''} onChange={(value) => setTempInfo({ ...tempInfo, termsOfService: value })} />
          {errors.termsOfService && <p className={styles.inlineAlerts}>{errors.termsOfService}</p>}
          <h4 className={styles.centeredHeading}>Contact</h4>
          <FormInput label={<>
            Name <span className={styles.requiredField}>*</span>
          </>} value={tempInfo?.contact?.name || ''} onChange={(value) => setTempInfo({ ...tempInfo, contact: { ...tempInfo.contact, name: value } })} />
          {errors.contactName && <p className={styles.inlineAlerts}>{errors.contactName}</p>}
          <FormInput label="URL" value={tempInfo?.contact?.url || ''} onChange={(value) => setTempInfo({ ...tempInfo, contact: { ...tempInfo.contact, url: value } })} />
          {errors.contactUrl && <p className={styles.inlineAlerts}>{errors.contactUrl}</p>}
          <FormInput label={<>
            Email <span className={styles.requiredField}>*</span>
          </>} value={tempInfo?.contact?.email || ''} onChange={(value) => setTempInfo({ ...tempInfo, contact: { ...tempInfo.contact, email: value } })} />
          {errors.contactEmail && <p className={styles.inlineAlerts}>{errors.contactEmail}</p>}

          <h4 className={styles.centeredHeading}>License</h4>
          <FormInput label="Name" value={tempInfo?.license?.name || ''} onChange={(value) => setTempInfo({ ...tempInfo, license: { ...tempInfo.license, name: value } })} />
          {selectedVersion === "3.1.0" && (
            <FormInput label="Identifier" value={tempInfo?.license.identifier || ''} onChange={(value) => setTempInfo({ ...tempInfo, license: { ...tempInfo.license, identifier: value } })} />
          )}
          <FormInput label="URL" value={tempInfo?.license?.url || ''} onChange={(value) => setTempInfo({ ...tempInfo, license: { ...tempInfo.license, url: value } })} />
          {errors.licenseUrl && <p className={styles.inlineAlerts}>{errors.licenseUrl}</p>}
          <div className={styles.sNcButtonContainer}>
            <button className={styles.saveButton} onClick={handleSave}>Save</button>
            <button className={styles.cancelButton} onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      ) : (
        <button className={styles.addNewButton} onClick={() => setTempInfo({ title: '', description: '', summary: '', version: '', termsOfService: '', contact: { name: '', url: '', email: '' }, license: { name: '', url: '', identifier: '' } })}>+ Add Info</button>
      )}
    </div>
  );
};

export default InfoSection;
